@if (activeLink) {
    <page-link-modal [modalable]="activeLink"></page-link-modal>
}
@if (activeQuickLink) {
    <page-quick-link-modal [modalable]="activeQuickLink"></page-quick-link-modal>
}
@if (activeHomework) {
    <page-homework-modal [modalable]="activeHomework"></page-homework-modal>
}
@if (activeWhiteboard) {
    <app-whiteboard-drawing-modal [modalable]="activeWhiteboard"></app-whiteboard-drawing-modal>
}
@if (activeWhiteboardVideo) {
    <app-whiteboard-video-modal [modalable]="activeWhiteboardVideo"></app-whiteboard-video-modal>
}
@if (activeYedoSign) {
    <app-yedo-modal [modalable]="activeYedoSign"></app-yedo-modal>
}
@if (activeEduSuiteSign) {
    <app-edu-suite-modal [modalable]="activeEduSuiteSign"></app-edu-suite-modal>
}
@if (activeDigbi) {
    <app-digbi-modal [modalable]="activeDigbi"></app-digbi-modal>
}
@if (activeAccessCode) {
    <app-access-code-modal [modalable]="activeAccessCode"></app-access-code-modal>
}
@if (activeAssignmentsLink) {
    <app-assignments-link-modal [modalable]="activeAssignmentsLink"></app-assignments-link-modal>
}
@if (modalService.disabledModalable) {
    <app-feature-disabled [modalable]="modalService.disabledModalable"></app-feature-disabled>
}
@if (homeworkExercisePreviewModalable) {
    <app-homework-exercise-preview-modal
            [modalable]="homeworkExercisePreviewModalable"></app-homework-exercise-preview-modal>
}
@if (applicationStateService.isOfflineModeEnabled) {
    <app-offline-mode-modal></app-offline-mode-modal>
}
<app-welcome-modal></app-welcome-modal>
<app-about-this-book-modal></app-about-this-book-modal>
<app-my-books-modal></app-my-books-modal>
<app-buy-book-modal></app-buy-book-modal>
<app-materials-modal></app-materials-modal>
<app-platform-link-copied-confirmation-modal></app-platform-link-copied-confirmation-modal>
<app-class-sharing-modal></app-class-sharing-modal>
<app-digi-trainer-modal></app-digi-trainer-modal>
<app-alert></app-alert>
<app-redirect-modal></app-redirect-modal>
@if (!applicationStateService.isOfflineModeEnabled && activeVideo) {
    <app-video-modal [modalAble]="activeVideo"/>
}
<app-offline-version-modal></app-offline-version-modal>
@if (applicationStateService.isOfflineModeEnabled) {
    <app-no-internet-modal></app-no-internet-modal>
}
<app-accessibility-modal></app-accessibility-modal>